export const 
CUSTOMER_APPROVE_DATA= 'CUSTOMER_APPROVE_DATA',
CUSTOMER_CHANGE_BUILDING_NUMBER= 'CUSTOMER_CHANGE_BUILDING_NUMBER',
CUSTOMER_CHANGE_CITY= 'CUSTOMER_CHANGE_CITY',
CUSTOMER_CHANGE_COUNTRY= 'CUSTOMER_CHANGE_COUNTRY',
CUSTOMER_CHANGE_EMAIL= 'CUSTOMER_CHANGE_EMAIL',
CUSTOMER_CHANGE_FLAT_NUMBER= 'CUSTOMER_CHANGE_FLAT_NUMBER',
CUSTOMER_CHANGE_TAX= 'CUSTOMER_CHANGE_TAX',
CUSTOMER_CHANGE_COMPANY_NAME= 'CUSTOMER_CHANGE_COMPANY_NAME',
CUSTOMER_CHANGE_NAME= 'CUSTOMER_CHANGE_NAME',
CUSTOMER_CHANGE_SURNAME='CUSTOMER_CHANGE_SURNAME',
CUSTOMER_CHANGE_NEW_CUSTOMER= 'CUSTOMER_CHANGE_NEW_CUSTOMER',
CUSTOMER_CHANGE_PHONE= 'CUSTOMER_CHANGE_PHONE',
CUSTOMER_CHANGE_PHONE_CODE = 'CUSTOMER_CHANGE_PHONE_CODE',
CUSTOMER_CHANGE_POSTAL_CODE= 'CUSTOMER_CHANGE_POSTAL_CODE',
CUSTOMER_CHANGE_STREET= 'CUSTOMER_CHANGE_STREET',
CUSTOMER_CHANGE_TYPE= 'CUSTOMER_CHANGE_TYPE',
CUSTOMER_CHANGE_TYPE_TO_COMPANY= 'CUSTOMER_CHANGE_TYPE_TO_COMPANY',
CUSTOMER_CHANGE_TYPE_TO_CORPORATE_ENTITY= 'CUSTOMER_CHANGE_TYPE_TO_CORPORATE_ENTITY',
CUSTOMER_INIT_BY_COMPANY= 'CUSTOMER_INIT_BY_COMPANY',
CUSTOMER_INIT_BY_COMPANY_FOR_PURCHASE_ADDRESS = 'CUSTOMER_INIT_BY_COMPANY_FOR_PURCHASE_ADDRESS',
CUSTOMER_VALIDATE= 'CUSTOMER_VALIDATE';



// WEBPACK FOOTER //
// ./src/types/Customer.js